import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";

@Component({
  selector: "new-home-profile-tab",
  templateUrl: "./new-home-profile-tab.component.html",
  styleUrls: ["./new-home-profile-tab.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewHomeProfileTabComponent {
  constructor(private newHomeExperienceService: NewHomeExperienceService) {}

  public get newHomeExpirienceSetting(): boolean {
    return this.newHomeExperienceService.isNewHomeExperienceSettingEnabled();
  }

  public setNewHomeExpirienceSetting(settingValue: boolean): void {
    this.newHomeExperienceService.setNewHomeExperienceSetting({ isEnabled: settingValue });
    setTimeout(() => window.location.reload(), 500);
  }
}
